var BlockView = require('views/block/base-block-view');
var ef = require('ef/ef');

let CommentView = BlockView.extend({
  initialize: function() {
    if(ef.forge_mode) {
      this.model.set('showPattern', true);
    }
    BlockView.prototype.initialize.apply(this, arguments);
  },
  load: function() {
    return this.renderNestedBlocks(`${this.model.get('cid')}-blocks`, this.model.get('blocks'));
  },
  play: function() {
    this.readyToGo();
  }
});

export default CommentView;
